import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


function sectorAccordions() {
    const sectors = $qsa('[data-name="sector-container"]');
    const sectorPins = $qsa('[data-name="sector-pin"]');

    if (!sectorPins || window.innerWidth < 1024) return;

    let pins = 0;

    [...sectorPins].forEach((sectorPin) => {

// let animation = gsap.fromTo(progressBar,{scaleY: 0.2},{scaleY: 1, transformOrigin: 'top'})
if(pins + 1 != sectorPins.length){
    console.info('pin section' + pins + ':' + sectorPins.length);
    let trigger = sectorPins[pins + 1]
    let pinProgress = ScrollTrigger.create({
		trigger: trigger,
		pin: sectorPin,
		pinSpacing: false,
		start: " bottom bottom",
		end: "bottom bottom",
        endTrigger: sectors,
		// markers: true,
        scrub: true,
        // animation: animation
	   
	  });
    }

      pins++;

    })


}


export default sectorAccordions;